const checkboxStyles = theme => ({
  root: {
    color: '#2974FF !important',
    display: 'flex !important',
    width: '100% !important',
    // 'margin-top': theme.spacing.unit * 2,
  },
  checked: { color: '#2974FF !important' },
  default: { color: '#2974FF !important' },
});

export default checkboxStyles;



// WEBPACK FOOTER //
// ./src/components/checkbox/CheckboxStyles.js